export const staffInfo = {
0:{id:0, name:'Kathaleen Denning',deskId:'desk1'},
1:{id:1, name:'Jong Pacifico',deskId:'desk2'},
2:{id:2, name:'Loni Tea',deskId:'desk3'},
3:{id:3, name:'Jacqulyn Kilpatrick',deskId:'desk4'},
4:{id:4, name:'Kendal Pae',deskId:'desk70'},
5:{id:5, name:'Simona Amburn',deskId:'desk21'},
6:{id:6, name:'Julietta Claybrooks',deskId:'desk15'},
7:{id:7, name:'Heidy Zehr',deskId:'desk22'},
8:{id:8, name:'Rickey Tiller',deskId:''},
9:{id:9, name:'Venetta Appell',deskId:''},
10:{id:10, name:'Eddy Dougherty',deskId:''},
11:{id:11, name:'Trudie Debusk',deskId:''},
12:{id:12, name:'Eda Shih',deskId:''},
13:{id:13, name:'Darline Beebe',deskId:''},
14:{id:14, name:'Major Royals',deskId:''},
15:{id:15, name:'Cordelia Behler',deskId:''},
16:{id:16, name:'Sean Scaggs',deskId:''},
17:{id:17, name:'Alishia Aschenbrenner',deskId:''},
18:{id:18, name:'Brant Shiley',deskId:''},
19:{id:19, name:'Duane Bordner',deskId:''},
20:{id:20, name:'Han Canales',deskId:''},
21:{id:21, name:'Howard Ristau',deskId:''},
22:{id:22, name:'Gudrun Harshberger',deskId:''},
23:{id:23, name:'Migdalia Star',deskId:''},
24:{id:24, name:'Nova Kesterson',deskId:''},
25:{id:25, name:'Kayleigh Stanforth',deskId:''},
26:{id:26, name:'Hee Hommel',deskId:''},
27:{id:27, name:'Timika Mcshan',deskId:''},
28:{id:28, name:'Ming Fawley',deskId:''},
29:{id:29, name:'Hiram Billington',deskId:''},
30:{id:30, name:'Ailene Parry',deskId:''},
31:{id:31, name:'Nelia Yeaton',deskId:''},
32:{id:32, name:'Jodie Dymond',deskId:''},
33:{id:33, name:'Theresa Householder',deskId:''},
34:{id:34, name:'Teodora Spiker',deskId:''},
35:{id:35, name:'Luigi Gage',deskId:''},
36:{id:36, name:'Ruth Curnutte',deskId:''},
37:{id:37, name:'Quyen Marsland',deskId:''},
38:{id:38, name:'Miles Weese',deskId:''},
39:{id:39, name:'Tajuana Mowery',deskId:''},
40:{id:40, name:'Lacy Christian',deskId:''},
41:{id:41, name:'Maragret Schank',deskId:''},
42:{id:42, name:'Keren Pearman',deskId:''},
43:{id:43, name:'Pauletta Aybar',deskId:''},
44:{id:44, name:'Theodora Dhillon',deskId:''},
45:{id:45, name:'Shenika Crook',deskId:''},
46:{id:46, name:'Gabrielle Encarnacion',deskId:''},
47:{id:47, name:'Jacquelyn Service',deskId:''},
48:{id:48, name:'Lynn Kirwan',deskId:''},
49:{id:49, name:'Carlyn Laborde',deskId:''}}


// WEBPACK FOOTER //
// ./src/assets/staff_list.js